// import { PUBLIC_URL } from "../../../next-env";

import { alpha, getContrastRatio } from "@mui/material";
import { COLORS } from "../styles/theme";
import { font } from "../styles/font";
import {
  blue,
  brown,
  green,
  grey,
  lime,
  purple,
  red,
  yellow,
} from "@mui/material/colors";

let PUBLIC_URL = {
  production: "https://floxpad.com/api",
  development: "https://dev.floxpad.com/api",
  // url: "http://localhost:5000"
};

export const isProductionMode = process.env.REACT_APP_MODE === "production";

const Config = {
  app: {
    logoUrl: "/images/latestLogo.webp",
    appName: "Floxpad",
    appVersion: "0.4.2",

    baseUrl: isProductionMode ? "" : "",
    consoleMode: isProductionMode ? "production" : "development",
  },

  api: {
    minute: 4,

    baseUrl: isProductionMode
      ? process.env.REACT_APP_API_URL
      : process.env.REACT_APP_API_URL,
    hostUrl: isProductionMode
      ? `${process.env.REACT_APP_API_URL}`
      : `${process.env.REACT_APP_API_URL}`,
  },
};

export class APP_CONFIG {
  static appName = "Floxpad";
  static appVersion = "0.7.0";
}

export class API_CONFIG {
  static minute = 4;

  static timeout = this.minute * 60 * 1000; // minutes
}

export class APP_URL {
  static base_url = isProductionMode ? "" : "";
}

export class HOST_URL {
  // static base_url = isProductionMode ? PUBLIC_URL.production : PUBLIC_URL.development;
  static base_url = isProductionMode
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL;

  static host_url = isProductionMode ? `${this.base_url}` : `${this.base_url}`;
}

export class BASE_URL {
  static base_url = "";
}

export class MAIN_URL {
  static url = HOST_URL.host_url + BASE_URL.base_url;
}

export class CONSOLE_MODE {
  static mode = isProductionMode ? "production" : "development";
}

export class REQUEST_URL {
  static aiChat = "/ai";
  static login = "/authenticate";
  static register = "/register";
  static verify = "/verify";
  static requestOTP = "/requestOTP";
  static extendSession = "/extendSession";

  static profile = "/profile";
  static updatePassword = `${this.profile}/updatePassword`;
  static invite = `${this.profile}/invite`;
  static teamsList = `${this.profile}/members`;
  static teamsRole = `${this.teamsList}/role`;
  static teamsRemove = `${this.teamsList}/remove`;

  static fetchCompanyId = "/fetchCompanyId";

  static admin = "/admin";
  static adminDashboard = `${this.profile}${this.admin}/dashboard`;
  static organisation = `${this.admin}/company`;
  static licensePlan = `${this.admin}/plans`;
  static licenseAddOn = `${this.admin}/addOn`;
  static payment = `${this.admin}/payment`;
  static markPayment = `${this.payment}/mark`;
  static trialPayment = `${this.payment}/trial`;
  static subscription = `/subscription`;
  static subscriptionInvoices = `${this.subscription}/invoices`;

  static labels = "/labels";

  static category = "/categories";

  static executionExportExcel = "/execution/testcase/export-excel";

  static aiCompletion = "/ai/completions";
  static aiModels = "/ai/models";
  static aiCredentials = "/admin/ai-credentials";
  static aiCredentialsTest = "/admin/ai-credentials/test";
  static aiCredentialsValidate = "/admin/ai-credentials/validate";

  static projects = "/projects";
  static projectStatus = `${this.projects}/status`;
  static projectDetail = `${this.projects}/details`;
  static projectLogs = `/logs`;
  static assignUsers = `${this.projects}/assignUsers`;
  static assignProjects = `${this.projects}/assignProjects`;
  static removeProjects = `${this.projects}/removeProjects`;

  static folder = "/folder";
  static folderStructure = `${this.folder}/explorer`;
  static folderLinkItems = `${this.folder}/link`;
  static folderMove = `${this.folder}/move`;

  static userStory = "/userstory";

  static userStoryPropertiesList = `${this.userStory}/properties`;
  static userStoryPriority = `${this.userStory}/priority`;
  static userStoryType = `${this.userStory}/type`;
  static userStoryMOSCOW = `${this.userStory}/moscow`;
  static userStoryConfidenciality = `${this.userStory}/confidentiality`;
  static userStoryStatus = `${this.userStory}/state`;

  static userStoryList = `${this.userStory}/list`;
  static userSingleStory = `${this.userStory}/detail`;
  static userStoryListAll = `${this.userStory}/list/all`;

  static userStoryLink = `${this.userStory}/link`;
  static userStoryCustomId = `${this.userStory}/fetch_customId`;
  static userStoryComment = `/comment`;

  static useCase = "/usecase";

  static useCasePropertiesList = `${this.useCase}/properties`;
  static useCasePriority = `${this.useCase}/priority`;
  static useCaseType = `${this.useCase}/type`;
  static useCaseStatus = `${this.useCase}/status`;
  static useCaseState = `${this.useCase}/state`;

  static useCaseList = `${this.useCase}/list`;
  static useSingleUseCase = `${this.useCase}/detail`;
  static useCaseListAll = `${this.useCase}/list/all`;

  static useCaseLink = `${this.useCase}/link`;
  static useCaseCustomId = `${this.useCase}/fetch_customId`;
  static useCaseComment = `/comment`;

  static testCase = "/testcase";

  static testCasePropertiesList = `${this.testCase}/properties`;
  static testCasePriority = `${this.testCase}/priority`;
  static testCaseType = `${this.testCase}/type`;
  static testCaseStatus = `${this.testCase}/status`;
  static testCaseState = `${this.testCase}/state`;

  static testCaseList = `${this.testCase}/list`;
  static useSingleTestCase = `${this.testCase}/detail`;
  static testCaseListAll = `${this.testCase}/list/all`;

  static testCaseLink = `${this.testCase}/link`;
  static testCaseCustomId = `${this.testCase}/fetch_customId`;
  static testCaseComment = `/comment`;

  
  static aiChatConversation = `${this.aiChat}/conversation`;
  static aiChatSave = `${this.aiChat}/save`;
  static aiChatGenerate = `${this.aiChat}/generate`;
  static aiChatEntity = `${this.aiChat}/entity`;
  static aiChatHistory = `${this.aiChat}/history`;

  static file = "/files";

  static improveText = `${this.aiChat}/improve-text`;
  static standaloneLicense= `${this.admin}/licenses`;

  static dashboard = "/dashboard";
  static planning = "/planning";
  static dashboardUserStoryList = `${this.dashboard}${this.userStory}`;
  static dashboardUseCaseList = `${this.dashboard}${this.useCase}`;
  static dashboardTestCaseList = `${this.dashboard}${this.testCase}`;
  static dashboardReleasePlanningData = `${this.planning}${this.dashboard}`;

  static dashboardChart = `${this.dashboard}/chart`;
  static dashboardProjectCountersList = `${this.dashboard}/project`;

  static dashboardRiskList = `${this.dashboard}/risk`;
  static dashboardActionsList = `${this.dashboard}/actions`;
  static dashboardIssuesList = `${this.dashboard}/issues`;
  static dashboardDependencyList = `${this.dashboard}/dependency`;
  static dashboardDecisionList = `${this.dashboard}/decision`;

  static dashboardReport = `${this.dashboard}/report`;
  static dashboardReportList = `${this.dashboardReport}/list`;
  static dashboardReportDetail = `${this.dashboardReport}/detail`;

  static traceabilityMatrixDetail = "/traceability/matrix";
  static traceabilitySaved = "/traceability/saved";
  static traceabilitySavedList = "/traceability/saved/list";
  static traceabilitySavedMatrix = "/traceability/saved/matrix";

  static release = "/release";
  static folderStructureRelease = `${this.release}/explorer`;
  static releaseDetail = `${this.release}/detail`;
  static releaseBacklog = `${this.release}/backlog`;
  static releaseFetchName = `${this.release}/fetch_name`;

  static sprint = "/sprint";
  static sprintDetail = `${this.sprint}/detail`;
  static sprintList = `${this.sprint}/list`;
  static sprintFetchName = `${this.sprint}/fetch_name`;

  static testSet = "/testSet";
  static folderStructureExecution = `${this.testSet}/explorer`;
  static testSetDetail = `${this.testSet}/detail`;

  static regression = "/regression";
  static createPlan = `${this.regression}`;
  static updatePlan = `${this.regression}`;
  static deletePlan = `${this.regression}`;
  static getPlan = `${this.regression}/get`;
  static listPlans = (projectName) =>
    `${this.regression}?projectName=${projectName}`;
  static updateTestCaseFiles = `${this.regression}/testcase-files`;
  static executePlan = `${this.regression}/execute`;

  static execution = "/execution";
  static executionManual = `${this.execution}/manual`;
  static executionTestCase = `${this.execution}/testcase`;
  static executionTestCaseList = `${this.executionTestCase}/list`;
  static executionTestCaseDetail = `${this.testCase}/detail`;
  static executionLatest = `${this.execution}/latest`;
  /** POST multipart: create Bugzilla bug from execution step (backend contract). */
  static bugzillaCreateBug = `${this.executionTestCase}/bugzilla/bug`;

  static automation = "/automation";
  static automationFiles = `${this.automation}/files`;
  static automationFilesBulk = `${this.automationFiles}/bulk`;
  static automationFilesList = `${this.automationFiles}/fetch_list`;
  static automationFileContent = `${this.automationFiles}/fetch_content`;
  static automationExecute = `${this.automationFiles}/automation`;
  static devices = "/devices/devicesByEmail";

  // ================= BOUNDARY CONFIGURATION ENDPOINTS =================
  static boundaryConfig = "/boundary-config";
  static saveBoundaryConfig = `${this.regression}${this.boundaryConfig}`;
  static getBoundaryConfig = `${this.regression}${this.boundaryConfig}`;
  static updateBoundaryConfig = `${this.regression}${this.boundaryConfig}`;
  static deleteBoundaryConfig = `${this.regression}${this.boundaryConfig}`;

  // ================= BOUNDARY TESTING ENDPOINTS =================
  static generateBoundaryValues = `${this.automationFiles}/generate_boundary_values`;
  static boundaryCategories = `${this.automationFiles}/boundary_categories`;
  static fetchBoundaryValues = `${this.automationFiles}/fetch_boundary_values`;
  static updateBoundaryValues = `${this.automationFiles}/update_boundary_values`;
  static fetchFieldNames = `${this.automationFiles}/fetch_field_names`;

  // ================= BOUNDARY EXECUTION ENDPOINTS =================
  static executeWithBoundary = `${this.regression}/execute/boundary`;
  static executePlanWithBoundary = `${this.regression}/execute`;

  static roles = "/role";
  static accessPermission = `${this.roles}/matrix`;

  static linkname = "/link";
  static linkRelated = `${this.linkname}/related`;

  static task = "/task";

  // ================= TEAMS MODULE =================

  static team = "/usermgmt/team";
  static teamList = `${this.team}/list`;
  static teamDetails = `${this.team}`;
  static createTeam = `${this.team}`;
  static updateTeam = `${this.team}`;
  static deleteTeam = `${this.team}`;
}

export class ModulePath {
  static login = "/login";
  static register = "/register";
  static forgotPassword = "/forgot-password";
  static verifyAccount = "/verify-account";
  static resetPassword = "/reset-password";
  static profile = "/profile";

  static home = "/home";
  static story = "/story";
  static marketplace = "/marketplace";
  static execution = "/execution";
  static settings = "/settings";
   static marketplace = "/marketplace";

  static projects = "/project";
  static programmes = "/programme";
  static departments = "/department";
  static organisations = "/organisation";
  static admin = "/settings";
  static superAdmin = "/super-admin";
  // static settings = "/settings"
  static requirements = "/userstory";
  static useCase = "/usecase";
  static testCase = "/testcase";
  static task = "/task";
  static planning = "/planning";
  static myActivity = "/myactivity";
  static dashboard = "/dashboard";
  static configuration = "/configuration";
  static regression = "/regression";
}

export const AuthPages = [
  ModulePath.login,
  ModulePath.register,
  ModulePath.forgotPassword,
  ModulePath.verifyAccount,
  ModulePath.resetPassword,
];

export class Severity {
  static success = "success";
  static info = "info";
  static warning = "warning";
  static error = "error";
}

export class AI_Entity {
  static module = "Modules";
  static userStory = "UserStory";
  static useCase = "UseCase";
  static testCase = "TestCase";
  static folder = "Folders";
  static dashboard = "Dashboard";

  static release = "Release";
  static sprint = "Sprint";
  static testSet = "TestSet";
}

export class AI_Response_SentBy {
  static user = "USER";
  static model = "FLOXPAD";
}

export class FolderType {
  static module = "module";
  static project = "project";
  static folder = "folder";
}

export class StoryStatus {
  static backlog = "BACKLOG";
  static todo = "TODO";
  static pending = "Pending";
  static inprogress = "INPROGRESS";
  static completed = "COMPLETED";
}

export class Entity_Label {
  static project = "Project";
  static programme = "Programme";
  static organisation = "Organisation";

  static module = "Module";

  static userStory = "User Story";
  static useCase = "Use Case";
  static testCase = "Test Case";
  static planning = "Release Plan";
  static release = "Release";
  static sprint = "Sprint";
  static execution = "Test Plan";
  static testSet = "Test Set";

  static folder = "Folder";

  static dashboard = "Dashboard";
  static dashboardReport = "Report";
  static configuration = "Configuration";
  static c;
  static task = "Task";
  static tasks = "Tasks";
  static regression = "Regression";
  static report = "Report";
}

export class Entity {
  static project = "Project";
  static programme = "Programme";
  static organisation = "Organisation";
  static userStory = "UserStory";
  static useCase = "UseCase";
  static testCase = "TestCase";
  static planning = "Planning";
  static release = "Release";
  static sprint = "Sprint";
  static execution = "Execution";
  static testSet = "TestSet";
  static folder = "Folders";
  static dashboard = "Dashboard";
  static configuration = "Configuration";
  static task = "Task";
  static regression = "Regression";
  static report = "Report";
}

export class FileType {
  static imageList = ["image/jpeg", "image/png", "image/jpg"];
  static pdfList = ["application/pdf"];
  static documentList = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/doc",
    "application/docx",
  ];
  static excelList = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/xls",
    "application/xlsx",
  ];
  static videoList = ["video/mp4"];
}

export class VerificationType {
  static Account = "Account";
  static ForgotPassword = "ForgotPassword";
}

export class VerificationStatus {
  static Verified = "Verified";
  static Unverified = "Unverified";
  static Invited = "Invited";
}

export class RiskStatus {
  static open = "OPEN";
  static close = "CLOSE";
}

export class IssueType {
  static time = "TIME";
  static cost = "COST";
  static quality = "QUALITY";
}

export class ImpactType {
  static mild = "Mild";
  static moderate = "Moderate";
  static severe = "Severe";
}

export class Priority {
  static high = "High";
  static medium = "Medium";
  static low = "Low";
}

export class Probability {
  static high = "High";
  static medium = "Medium";
  static low = "Low";
}

export class AutomationFileType {
  static element = "ELEMENT";
  static application = "APPLICATION";
  static testData = "TESTDATA";
  static script = "SCRIPT";
}

export class ExecutionType {
  static manual = "Manual";
  static automation = "Automation";
}

export class Application_Module {
  static role = "Role";
  static project = "Project";
  static userStory = "UserStory";
  static useCase = "UseCase";
  static testCase = "Test Case";
  static planning = "Planning";
  static execution = "Execution";
  static dashboard = "Dashboard";
  static cost = "Cost";
  static counters = "Counters";
  static risk = "Risk";
  static action = "Action";
  static issues = "Issues";
  static dependency = "Dependency";
  static decisions = "Decisions";
  static task = "Task";
  static team = "Team";
  static userManagement = "User Management";
  static roleManagement = "Role Management";
  static adminDashboard = "Admin Dashboard";
  static configuration = "Configuration";
  static report = "Report";
  static regression = "Regression";
}

export class Module_Actions {
  static read = "READ";
  static create = "CREATE";
  static update = "UPDATE";
  static delete = "DELETE";
}

export class Settings_Module {
  static license = "License";
  static userManagement = "User Management";
  static dashboard = "Admin Dashboard";
  static roleManagement = "Role Management";
  static profile = "Profile";
  static activityLog = "Activity Log";
  static permissions = "My Permissions";
  static teams = "Teams";
}

export class Super_Admin_Module {
  static organisation = "Organisation";
  static license = "License Plan";
  static licenseAddon = "License Add-on";
  static invoices = "Invoices";
  static standaloneLicense = "StandloneLicenses"
}

export class LicenseDuration {
  static monthly = "MONTHLY";
  static quarterly = "QUARTERLY";
  static annually = "ANNUALLY";
}

export class PaymentTerms {
  static prepaid = "PREPAID";
  static postpaid = "POSTPAID";
}

export class PlanBilling {
  static monthly = "MONTHLY";
  static quarterly = "QUARTERLY";
  static annually = "ANNUALLY";
}

export class USER_ROLE {
  static superadmin = "Superadmin";
  static admin = "ADMIN";
}

export class Dashboard_Entity {
  static report = {
    label: "Report",
    value: "Report",
  };
  static project = {
    label: "Project",
    value: "Project",
  };
  static projectDashboard = {
    label: "Project Dashboard",
    value: "Project",
  };
  static userStory = {
    label: "User Story",
    value: "UserStory",
  };
  static useCase = {
    label: "Use Case",
    value: "UseCase",
  };
  static testCase = {
    label: "Test Case",
    value: "TestCase",
  };
  static teams = {
    label: "Teams",
    value: "Teams",
  };
  static traceability = {
    label: "Traceability",
    value: "Traceability",
  };
  static cost = {
    label: "Cost",
    value: "Cost",
  };
  static userPersona = {
    label: "User Persona",
    value: "UserPersona",
  };
  static qualityAssurance = {
    label: "Quality Assurance",
    value: "QualityAssurance",
  };
  static planning = {
    label: "Release Planning",
    value: "Planning",
  };
  static execution = {
    label: "Test Planning",
    value: "Execution",
  };
  static risks = {
    label: "Risks",
    value: "Risks",
  };
  static action = {
    label: "Action",
    value: "Action",
  };
  static issues = {
    label: "Issues",
    value: "Issues",
  };
  static dependencies = {
    label: "Dependencies",
    value: "Dependencies",
  };
  static decision = {
    label: "Decisions",
    value: "Decisions",
  };
  static defect = {
    label: "Defect",
    value: "Defect",
  };
}

export const CHART_OPTIONS2 = {
  title: {
    display: true,
    text: " Chart Title",
    fontColor: COLORS.text,
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      // fontColor: alpha(COLORS.text, 0.8),
      // fontColor: COLORS.text,
      // fontSize: font.size.fs_sm,
      color: COLORS.text,
      font: {
        size: font.size.fs_sm,
      },
      // boxWidth : 20,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          fontColor: alpha(COLORS.text, 0.8),
        },
      },
    ],
  },
  plugins: {
    datalabels: {
      display: true,
      anchor: "end",
      align: "end",
      color: "black",
      font: {
        size: 12,
      },
      formatter: (value) => {
        return value;
      },
    },
  },
};

export const CHART_OPTIONS = {
  responsive: true, // Makes the chart resize based on its container
  maintainAspectRatio: false, // Allows you to override the default aspect ratio

  // Interaction options control how the user interacts with the chart
  interaction: {
    mode: "nearest", // 'point', 'nearest', 'index', 'dataset', 'x', 'y'
    intersect: false, // If true, only consider intersected elements
  },

  // Plugins allow you to extend the functionality of Chart.js
  plugins: {
    title: {
      display: true,
      text: "My Awesome Chart",
      font: {
        size: 16,
      },
      color: COLORS.text,
      padding: {
        top: 10,
        bottom: 30,
      },
      align: "center", // 'start', 'center', 'end'
    },
    legend: {
      display: true,
      position: "bottom", // 'top', 'bottom', 'left', 'right', 'chartArea'
      align: "center", // 'start', 'center', 'end'
      // formatter: (value, context) => {
      //   console.log(value, context, "valuecontext");

      //   let datasetLabel = context.dataset.label || '';

      //   if (context.dataset.data.length > 1) {
      //     datasetLabel = context.chart.data.labels[context.dataIndex];
      //   }

      //   // return `${datasetLabel}${datasetLabel && ":"} ${value}`; // Customize the label format
      //   return `${value}`; // Customize the label format
      // },
      labels: {
        color: COLORS.text,
        boxWidth: 20,
        padding: 10,
        font: {
          size: 10,
        },

        formatter: (value, context) => {
          console.log(value, context, "legend.labels.valuecontext");

          let datasetLabel = context.dataset.label || "";

          if (context.dataset.data.length > 1) {
            datasetLabel = context.chart.data.labels[context.dataIndex];
          }

          // return `${datasetLabel}${datasetLabel && ":"} ${value}`; // Customize the label format
          return `${"value1"}`; // Customize the label format
        },
      },
    },
    datalabels: {
      display: true,
      anchor: "center", // 'start', 'end', 'center'
      align: "center", // 'top', 'bottom', 'left', 'right', 'center'
      // formatter: (value, context) => {
      //   console.log(value, context, "valuecontext");

      //   let datasetLabel = context.dataset.label || '';

      //   if (context.dataset.data.length > 1) {
      //     datasetLabel = context.chart.data.labels[context.dataIndex];
      //   }

      //   // return `${datasetLabel}${datasetLabel && ":"} ${value}`; // Customize the label format
      //   return `${value}`; // Customize the label format
      // },
      color: "#FFFFFF",
      font: {
        size: 12,
        weight: "bold",
      },
      padding: {
        top: 4,
        bottom: 4,
      },
    },
    tooltip: {
      enabled: true,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      titleColor: "#fff",
      bodyColor: "#fff",
      borderColor: "#ddd",
      borderWidth: 1,
      // callbacks: {
      //   // You can customize the tooltip labels here
      //   label: (context) => {
      //     let label = context.dataset.label || '';
      //     if (label) {
      //       label += ': ';
      //     }
      //     if (context.parsed.y !== null) {
      //       label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
      //     }
      //     return label;
      //   },
      // },
    },
  },

  // Scales define the axes of the chart (e.g., x-axis, y-axis)
  scales: {
    //   x: {
    //     ticks: {
    //         callback: function (value, index, values) {
    //             const maxLength = 5;
    //             const label = this.getLabelForValue(value);
    //             if (label.length > maxLength) {
    //                 return label.substring(0, maxLength) + '...';
    //             }
    //             return label;
    //         },
    //     },
    // },
    // x: {
    //   type: 'category', // For categorical data (e.g., labels)
    //   labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4'], // Alternatively, provide in data
    //   title: {
    //     display: false,
    //     text: 'X-Axis Label',
    //     color: 'blue',
    //     font: {
    //       size: 14,
    //     },
    //   },
    //   grid: {
    //     display: false,
    //     color: 'rgba(0, 0, 0, 0.1)',
    //   },
    //   ticks: {
    //     color: 'green',
    //     beginAtZero: true, // For linear scales, start at zero
    //     callback: function (value, index, ticks) {
    //       // Customize the tick labels
    //       return value;
    //     }
    //   },
    // },
    // y: {
    //   type: 'linear', // For numerical data
    //   title: {
    //     display: false,
    //     text: 'Y-Axis Label',
    //     color: 'red',
    //     font: {
    //       size: 14,
    //     },
    //   },
    //   grid: {
    //     display: false,
    //     color: 'rgba(0, 0, 0, 0.1)',
    //   },
    //   ticks: {
    //     color: 'purple',
    //     beginAtZero: true,
    //     callback: function (value, index, ticks) {
    //       return '$' + value; // Format y-axis ticks as currency
    //     }
    //   },
    // },
    // You can define additional axes for more complex charts (e.g., a second y-axis)
    // y2: {
    //   type: 'linear',
    //   position: 'right',
    //   title: {
    //     display: true,
    //     text: 'Secondary Y-Axis',
    //     color: 'orange',
    //   },
    //   grid: {
    //     drawOnChartArea: false, // Don't draw grid lines on the main chart area
    //   },
    //   ticks: {
    //     color: 'orange',
    //   },
    // },
  },

  // Animation options control how the chart animates
  animation: {
    duration: 1000, // Animation duration in milliseconds
    easing: "easeInOutQuad", // Animation easing function
    // onComplete: () => { ... }, // Callback when the animation is complete
  },

  // Hover options control the appearance when the mouse hovers over elements
  hover: {
    mode: "nearest",
    intersect: true,
    animationDuration: 400,
  },
};

export const CHART_COLORS = [
  green,
  red,
  blue,
  yellow,
  lime,
  purple,
  brown,
  grey,
];

export const Editor_ModuleConfig = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
  ],
};
